import React, { createContext, useContext, useState, useEffect, useRef } from 'react';

import { v4 as uuidv4 } from 'uuid';

import { useAuth } from './AuthSkillContext';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Login from '../components/Auth/login';
import { set } from 'zod';

// Tworzenie kontekstu WebSocket
export const ManagerContext = createContext(null);

// Hook do korzystania z WebSocketContext
export function useWS() {
    return useContext(ManagerContext);
}
export function useManager() {
    return useContext(ManagerContext);
}

// Provider WebSocket
export const WebSocketProvider = ({ children }) => {
    const theme = useTheme();
    const is_xs = useMediaQuery(theme.breakpoints.down('xs'));
    const is_sm = useMediaQuery(theme.breakpoints.down('sm'));
    const is_md = useMediaQuery(theme.breakpoints.down('md'));
    const is_lg = useMediaQuery(theme.breakpoints.down('lg'));
    const is_xl = useMediaQuery(theme.breakpoints.down('xl'));
    const is_xxl = useMediaQuery(theme.breakpoints.down('xxl'));
    const is_xxxl = useMediaQuery(theme.breakpoints.down('xxxl'));
    const display = () => {
        if (is_xs) return 0
        if (is_sm) return 1
        if (is_md) return 2
        if (is_lg) return 3
        if (is_xl) return 4
        if (is_xxl) return 5
        if (is_xxxl) return 6
        return null
    }
    const [ lastId, setLastId ] = React.useState(null);
    const wsRef = useRef(null); // Referencja do WebSocket
    const [ currentPage, setCurrentPage ] = useState(0);
    const messagePromisesRef = useRef({}); // Obiekt do śledzenia obietnic
    const pingIntervalRef = useRef(null); // Referencja do setInterval
    const pongTimeoutRef = useRef(null); // Referencja do setTimeout
    // const { setUser, currentUser } = useAuth();
    const [ currentUser, setCurrentUser] = useState(null)
    const [ backDrop, setBackDrop ] = React.useState(true);
    const [ block, setBlock ] = useState(true)
    const [ contexts, setContexts ] = useState([]);
    const [ authFromServer, setAuthSkill ] = useState([]);
    const [ connectionState, setConnectionState ] = useState('CLOSED');
    const [ messages, setMessages ] = useState([]); // Opcjonalne: przechowywanie wiadomości
    const messagesRef = useRef(null);
    const [ isInit, setIsInit ] = useState(false);
    const [ openaiApiKey, setOpenaiApiKey ] = useState(null)
    const [ language, setLanguage ] = useState(null);
    
    const PING_INTERVAL = 5000; // Co 5 sekund wysyłamy PING
    const PONG_TIMEOUT = 15000; // 15 sekund na odpowiedź PONG

    const htmlServer = 'https://my-fastapi-service-325267344341.europe-west4.run.app'
    const wsServer = 'wss://my-fastapi-service-325267344341.europe-west4.run.app/ws'
    const urlServer = 'my-fastapi-service-325267344341.europe-west4.run.app';
    const urlType = 1;

    // const urlServer = '34.91.136.28:8000';
    // const htmlServer = 'http://34.91.136.28:8000';
    // const wsServer = 'ws://34.91.136.28:8000/ws';
    // const urlType = 0;
    
    
    

    
    function setSessionId(sessionId) {
        // Sprawdzenie, czy numer sesji już istnieje
        const existingSessionId = sessionStorage.getItem('sessionId');
        
        if (existingSessionId) {
            // console.log(`Numer sesji już istnieje: ${existingSessionId}`);
        } else {
            // Ustawienie nowego numeru sesji
            sessionStorage.setItem('sessionId', sessionId);
            console.log(`Ustawiono nowy numer sesji: ${sessionId}`);
        }
    }

    // Funkcja do ustawiania numeru sesji
    function setUserTag(userTag) {
        // Sprawdzenie, czy numer sesji już istnieje
        const existingUserTag = localStorage.getItem('userTag');
        
        if (existingUserTag) {
            // console.log(`UserTag już istnieje: ${existingUserTag}`);
        } else {
            // Ustawienie tagu
            localStorage.setItem('userTag', userTag);
            console.log(`Ustawiono nowy userTag: ${userTag}`);
        }
    }

    

    useEffect(() => {

        const init = async () => {
            const response = await fetch(`${htmlServer}/api/getApiKey`);
            const data = await response.json();
            setOpenaiApiKey(data.api_key);
            const init_data = await sendTask('init')
            setLanguage(init_data.data.language)
            await updateCurrentUser();
            setIsInit(true)
        }

        if (connectionState === 'OPEN') {
            init();
        }

    }, [connectionState])

    setSessionId(generateSessionToken(16))
    setUserTag(generateSessionToken(16))

    function generateSessionToken(length) {
        // Zestaw znaków, z którego będziemy tworzyć token
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let token = '';
        
        // Generowanie losowego ciągu znaków z wykorzystywaniem podanego zestawu
        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            token += characters.charAt(randomIndex);
        }
        return token;
    }

    const updateCurrentUser = async () => {
        const result = await sendTask('get_current_user')
        if (result) {
            console.log('updateCurrentUser', result.current_user)
            setCurrentUser(result.current_user)
            return result.current_user;
        }
    }
    
    const reconnect = () => {
        console.log('Attempting to reconnect...');
        // Ustawienie nowego WebSocket
        wsRef.current = new WebSocket(`${urlType===0?'ws://':'wss://'}${urlServer}/ws`)
        // wsRef.current = new WebSocket('wss://my-fastapi-service-325267344341.europe-west4.run.app/ws');

        wsRef.current.onopen = () => {
            startPing(); // Rozpoczęcie pingowania
            const userTag = localStorage.getItem('userTag');
            const sessionId = sessionStorage.getItem('sessionId');
            if (userTag && sessionId) {
                wsRef.current.send(`${userTag}_${sessionId}`);
            }
            setConnectionState('OPEN');
            
            
            console.log('WebSocket connection opened');
        };

        // Obsługa odebrania wiadomości
        wsRef.current.onmessage = (event) => {
            const data = event.data;
            // console.warn(event.data)
            
            if (data === 'PONG') {
                // console.log('PONG received');
                setBlock(false)
                clearTimeout(pongTimeoutRef.current); // Resetowanie timeoutu
                // Opcjonalnie: dodatkowe logiki przy odbiorze PONG
            } else {
                // Obsługa innych wiadomości
                try {
                    const parsedData = JSON.parse(data);
                    console.log('Parsed data:', parsedData)
                    if (parsedData.currentUser){
                        setCurrentUser(parsedData.currentUser)
                    }
                    setMessages(prevMessages => [...prevMessages, parsedData]);
                    // Możesz również aktualizować inne stany na podstawie odbieranych danych
                    if (parsedData.contexts) {
                        setContexts(data.contexts);
                    }
                    if (parsedData.message) {
                        setMessages(prevMessages => [...prevMessages, event.data]);
                    }
                    if (parsedData.authSkill) {
                        setAuthSkill(parsedData.authSkill);
                        messagesRef.current = parsedData.message;
                        console.log('authSkill');
                    }  
                    if (messagePromisesRef.current[parsedData.id]) {
                        messagePromisesRef.current[parsedData.id].resolve(parsedData);
                        delete messagePromisesRef.current[parsedData.id]; // Usuń po zakończeniu
                    }
                } catch (error) {
                    console.error('Failed to parse message:', error);
                }
            }
        };

        wsRef.current.onclose = (event) => {
            console.log('WebSocket connection closed:', event);
            setConnectionState('CLOSED');
            stopPing(); // Zatrzymanie pingowania
            // Zainicjuj ponowne połączenie po 3 sekundach
            setTimeout(reconnect, 3000);
            // wsRef.current.close()
        };

        wsRef.current.onerror = (error) => {
            console.error('WebSocket error:', error);
            setConnectionState('ERROR');
        };

        return () => {
            wsRef.current.close();
        };
    };

    useEffect(() => {
        reconnect(); // Inicjalizacja WebSocket
        return () => {
            if (wsRef.current) {
                wsRef.current.close();
                wsRef.current = null;
                console.log('Close connection');
            }
        };
    }, []);

    // Funkcja do rozpoczęcia pingowania
    const startPing = () => {
        if (pingIntervalRef.current) return; // Zapobiega wielokrotnemu uruchomieniu

        pingIntervalRef.current = setInterval(() => {
            if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
                // console.log('Sending PING...');
                wsRef.current.send('PING'); // Wysłanie PING

                // Ustawienie timeoutu na odpowiedź PONG
                pongTimeoutRef.current = setTimeout(() => {
                    // console.warn('block', block)
                    if (!block){
                        console.warn('No PONG received within timeout, closing connection...');
                        wsRef.current.close(); // Zamknięcie połączenia, jeśli brak PONG
                        // connectWebSocket();
                    }
                    setBlock(true)
                }, PONG_TIMEOUT);
            }
        }, PING_INTERVAL);
    };

    // Funkcja do zatrzymania pingowania
    const stopPing = () => {
        if (pingIntervalRef.current) {
            clearInterval(pingIntervalRef.current);
            pingIntervalRef.current = null;
        }
        if (pongTimeoutRef.current) {
            clearTimeout(pongTimeoutRef.current);
            pongTimeoutRef.current = null;
        }
    };

    // Użycie useEffect do inicjalizacji i czyszczenia połączenia WebSocket
    // useEffect(() => {
    //     // Inicjalizacja połączenia WebSocket
    //     // connectWebSocket();

    //     // Czyszczenie zasobów przy odmontowaniu komponentu
    //     return () => {
    //         stopPing(); // Zatrzymanie pingowania
    //         if (wsRef.current) {
    //             wsRef.current.close(); // Zamknięcie połączenia WebSocket
    //             wsRef.current = null;
    //         }
    //     };
    // }, []); // Pusta tablica zależności oznacza uruchomienie tylko raz przy montowaniu

    // Funkcja do wysyłania wiadomości przez WebSocket
    const sendMessage = (map) => {
        
        if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
            map.set("timestamp", Date.now)
            const obj = Object.fromEntries(map)
            wsRef.current.send(JSON.stringify(obj));
        }
    };

    const logout = async () => {
        const result = await sendTask('logout');
        setCurrentUser(null)
    }


    const sendAuth = (map) => {
        if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
            const messageId = uuidv4(); // Generowanie unikalnego identyfikatora
            map.set("timestamp", Date.now)
            map.set('name', 'authSkill')
            map.set('id', messageId)
            const obj = Object.fromEntries(map)
            
            return new Promise((resolve, reject) => {
                if (wsRef.current.readyState === WebSocket.OPEN) {
                    console.log('sending message auth', messageId)
                    messagePromisesRef.current[messageId] = { resolve, reject }; // Przechowywanie obietnicy
                    wsRef.current.send(JSON.stringify(obj));
                } else {
                    reject(new Error('WebSocket nie jest otwarty. Stan: ' + wsRef.current.readyState));
                }
            });
        }
    };

    const sendTask = (task, data) => {
        const map = new Map();
        map.set("task", task);
        if (data) map.set("data", data);
        if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
            const messageId = uuidv4(); // Generowanie unikalnego identyfikatora
            map.set("timestamp", Date.now)
            map.set('name', 'authSkill')
            map.set('id', messageId)
            const obj = Object.fromEntries(map)
            
            return new Promise((resolve, reject) => {
                if (wsRef.current.readyState === WebSocket.OPEN) {
                    // console.log('sending message auth', messageId)
                    messagePromisesRef.current[messageId] = { resolve, reject }; // Przechowywanie obietnicy
                    wsRef.current.send(JSON.stringify(obj));
                } else {
                    reject(new Error('WebSocket nie jest otwarty. Stan: ' + wsRef.current.readyState));
                }
            });
        }
    };

    const value={ 
        isInit,
        openaiApiKey,
        urlType,
        urlServer,
        logout, 
        currentUser, 
        messagesRef, 
        connectionState, 
        contexts, 
        sendMessage, 
        sendAuth, 
        sendTask,
        authFromServer, 
        setAuthSkill,
        currentPage, setCurrentPage, 
        lastId, setLastId,
        is_xs, is_sm, is_md, is_lg, is_xl, is_xxl, is_xxxl, display,
    }

    return (
        <ManagerContext.Provider value={value}>
            {children}
        </ManagerContext.Provider>
    );
};
